<script>
import { mapGetters, mapActions } from "vuex";
import appconfig from '@/store/modules/appconfig'
import { Get, Post } from '@/modules/wrapper/apiWrapper'
import * as Helper from "@/modules/helper/index";
export default {
  data() {
      return {
       name:'',
       Isvalidpass: false,
       Enterpass: false
    }
  },
  computed: {
    ...mapGetters([
      "TeamMember",
      "MainMenuLayout",
      "resource",
      "appconfig"
      ])
  },
  methods: {
    async Validatepassword() {
      this.Isvalidpass = false
      this.Enterpass = false
      if (this.name != "") {
        let SubscriptionModuleId = this.$f7route.params.Id ? this.$f7route.params.Id : this.$f7route.params.SubscriptionModuleId
        let payload = {
          'Id' : SubscriptionModuleId,
          'AccessPassword' : this.name
        }
        let result =  await Post(`${appconfig.state.AppConfig.Urls.WebAPIURL}/api/SubscriptionsModulesAuth/ValidateModulePassword`, payload)
        if (result) {
          //console.log('params', this.$f7route.query)
          //router.push({ path: 'register', query: { plan: 'private' }})
          this.$f7.views.main.router.navigate(`${this.$f7route.path}?isUnLock=true`)
        } else {
          this.Isvalidpass = true
          this.Enterpass = false
        }
      } else {
        this.Isvalidpass = false
        this.Enterpass = true
      }
    }
  },
  created() {
    // console.log("in lock screen created");
  },
  mounted() {
    // console.log("in lock screen mounted");
  }
};
</script>

<template>
<f7-page ref="lockviewPage" class="access-lock" :page-content="false" name="lock-view">
    <app-header ></app-header>
    <f7-page-content>
      <h2 class="access-lock-heading">{{resource.str_access_lock_heading}}</h2>
      <p class="access-lock-description">{{resource.str_access_lock_description}}</p>
      <f7-input
        type="password"
        size="large"
        @input="name = $event.target.value"
        :placeholder="resource.str_module_placeholde"        
      ></f7-input>
      <span class="error-msg" v-show="Isvalidpass">{{resource.str_error_msg}}</span>
      <span class="error-msg" v-show="Enterpass">{{resource.str_entrpass}}</span>
      <f7-button fill :outline="true" class="btn-lock-unlock" big @click="Validatepassword($event.target.value)">{{resource.str_btn_lock_unlock}}</f7-button>
    </f7-page-content>
  </f7-page>
</template>

<style scoped>
.btn-lock-unlock{
  font-size: 25px !important;
}
</style>





// WEBPACK FOOTER //
// src/components/shared/lockScreen.vue